import { IUpdateUser } from "../models/auth.model";

/**
 * Get the user's preferred language from localStorage
 * @returns The language code (en, zh, es) or null if not found
 */
export const getUserLanguage = (): string | null => {
  try {
    const userStr = localStorage.getItem("user");
    if (!userStr) return null;

    const user: IUpdateUser = JSON.parse(userStr);
    return user.language || null;
  } catch (error) {
    console.error("Error getting user language from localStorage:", error);
    return null;
  }
};

/**
 * Map language display names to language codes
 */
export const LANGUAGE_MAP: Record<string, string> = {
  English: "en",
  中文: "zh",
  Español: "es",
};

/**
 * Maps database language values to i18n translation keys
 */
export const LANGUAGE_DISPLAY_MAP: Record<string, string> = {
  "Multi-language": "agents.createAgentModal.multiLanguage",
  "English": "language.english", 
  "中文": "language.chinese",
  "Español": "language.spanish"
};

/**
 * Get the language code from the user's language preference
 * @param userLanguage The language string from user profile
 * @returns The language code or 'en' as fallback
 */
export const getLanguageCode = (
  userLanguage: string | null | undefined
): string => {
  if (!userLanguage) return "en";

  // If it's already a code, return it
  if (["en", "zh", "es"].includes(userLanguage)) {
    return userLanguage;
  }

  // Map display name to code
  return LANGUAGE_MAP[userLanguage] || "en";
};

/**
 * Gets the i18n translation key for a given language value from the database
 * @param languageValue - The language value stored in the database
 * @returns The i18n translation key, or the original value if no mapping exists
 */
export const getLanguageTranslationKey = (languageValue: string): string => {
  return LANGUAGE_DISPLAY_MAP[languageValue] || languageValue;
};

/**
 * Initialize language from fresh user data after API call
 * This should be called after getUserInfor API call completes
 */
export const initializeLanguageFromFreshData = (i18n: any): void => {
  const userLanguage = getUserLanguage();
  const languageCode = getLanguageCode(userLanguage);

  if (languageCode && i18n.language !== languageCode) {
    i18n.changeLanguage(languageCode);
  }
};
